module.exports = __webpack_public_path__ + "img/213.590b3303.svg";